import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PageTransition from '../components/PageTransition';
import '../styles/globals.css';

const LandingPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showTransition, setShowTransition] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get referral code from URL parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const referralCode = params.get('ref');
    if (referralCode) {
      sessionStorage.setItem('referredBy', referralCode);
    }
  }, [location]);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      const referredBy = sessionStorage.getItem('referredBy') || null;
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email,
          referralCode: referredBy
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Registration failed');
      }

      // Store the user's email, referral code and API key in sessionStorage
      sessionStorage.setItem('email', email);
      sessionStorage.setItem('referralCode', data.referralCode);
      sessionStorage.setItem('apiKey', data.apiKey);
      
      // Show transition before navigation
      setShowTransition(true);
      
      // Wait for transition animation
      setTimeout(() => {
        // Navigate to success page with the position from registration response
        navigate('/success', { 
          state: { 
            position: data.position,
            maxTarget: data.maxTarget,
            justRegistered: true 
          } 
        });
      }, 1500); // Adjust timing to match transition duration

    } catch (err) {
      console.error('Registration error:', err);
      if (err.message === 'Failed to fetch') {
        setError('Network error. Please check your connection and try again.');
      } else {
        setError(err.message || 'Registration failed. Please try again.');
      }
      setLoading(false);
    }
  };

  return (
    <div className="landing-container">
      <PageTransition isActive={showTransition} />
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 20, 20, 0.80)',
          zIndex: 0
        }}
      />
      <div className="rods rods-left">
        <svg width="100" height="100%" viewBox="0 0 100 800">
          <g className="rod-group">
            {[...Array(16)].map((_, i) => (
              <g key={i} transform={`translate(0, ${i * 50})`}>
                <rect className="rod-segment" x="0" y="0" width="40" height="8" />
                <rect className="rod-segment" x="40" y="2" width="35" height="4" />
                <rect className="rod-segment" x="70" y="3" width="35" height="2" />
              </g>
            ))}
          </g>
        </svg>
      </div>
      <div className="rods rods-right">
        <svg width="100" height="100%" viewBox="0 0 100 800">
          <g className="rod-group">
            {[...Array(16)].map((_, i) => (
              <g key={i} transform={`translate(0, ${i * 50})`}>
                <rect className="rod-segment" x="0" y="0" width="40" height="8" />
                <rect className="rod-segment" x="40" y="2" width="35" height="4" />
                <rect className="rod-segment" x="70" y="3" width="35" height="2" />
              </g>
            ))}
          </g>
        </svg>
      </div>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1
        }}
      >
        <source src="/plasma-promo.mp4" type="video/mp4" />
      </video>
      <img src="/logo.png" alt="Plasmafia Logo" className="logo" style={{ position: 'relative', zIndex: 1 }} />
      <h1 className="title" style={{ position: 'relative', zIndex: 1 }}>Join the Plasmafia Movement</h1>
      <h2 className="subtitle" style={{ position: 'relative', zIndex: 1 }}>Zero Fees is the future.</h2>
      <h2 className="subtitle" style={{ position: 'relative', zIndex: 1, marginTop: '0.5rem' }}>Loop in to The Plasmaverse | Pre-TGE Alpha and News</h2>
	  <form onSubmit={handleSubmit} noValidate style={{ position: 'relative', zIndex: 1 }}>
        <div className="pill-input">
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
            }}
            placeholder="Enter your email"
            className="email-input"
            disabled={loading}
          />
          <button 
            type="submit" 
            disabled={loading}
            className="submit-button"
          >
            {loading ? 'Loading...' : "Submit"}
          </button>
        </div>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
};

export default LandingPage; 
